module.exports = __webpack_public_path__ + "static/media/16559855_605.ef52b436.jpg";